module.exports = __webpack_public_path__ + "assets/img/slide-1.0008fb3f.svg";